
    import './styles.scoped.css';
    export default {
  "empty": "awsui_empty_n4qlp_h3o62_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_n4qlp_h3o62_1",
  "root": "awsui_root_n4qlp_h3o62_119",
  "row": "awsui_row_n4qlp_h3o62_137",
  "row-control": "awsui_row-control_n4qlp_h3o62_141",
  "field": "awsui_field_n4qlp_h3o62_145",
  "add-button": "awsui_add-button_n4qlp_h3o62_149",
  "remove-button": "awsui_remove-button_n4qlp_h3o62_153",
  "button-container": "awsui_button-container_n4qlp_h3o62_157",
  "divider": "awsui_divider_n4qlp_h3o62_161",
  "additional-info": "awsui_additional-info_n4qlp_h3o62_165",
  "right-align": "awsui_right-align_n4qlp_h3o62_211"
};
  